export default class ModifyNoicNameParam {
  constructor (id, phone, nickName) {
    this.id = id
    this.phone = phone
    this.nickName = nickName
  }
}
